module.exports = __webpack_public_path__ + "img/coin.810284e2.png";